import { Box } from '@ltvco/refresh-lib/theme';
import { FieldError } from '@ltvco/refresh-lib/vendors';
import React from 'react';

import { FormHelperErrorText } from '../components';

export interface WithErrorHandlingProps {
  error?: FieldError;
  name?: string;
  className?: string;
}

/**
 * HOC that adds error handling capabilities to an input component
 *
 * @param Component The component to enhance with error handling
 * @returns A new component with error handling
 */
export const withErrorHandling = <P extends object>(
  Component: React.ComponentType<P>
): React.ComponentType<P & WithErrorHandlingProps> => {
  return ({ error, className = '', ...props }: WithErrorHandlingProps & P) => {
    const hasError = !!error;
    const errorClassName = hasError ? 'error' : '';
    const combinedClassName = `${className} ${errorClassName}`.trim();

    return (
      <Box className={combinedClassName} sx={{ width: '100%' }}>
        <Component {...(props as P)} />
        {error && <FormHelperErrorText>{error.message}</FormHelperErrorText>}
      </Box>
    );
  };
};
